import api from './api';

const PerguntaService = {
  // Método para obter todas as perguntas
  getPerguntas: async () => {
    try {
      const response = await api.get(`/admin/listar-perguntas`);
      return response.data; // Retorna os dados da resposta
    } catch (error) {
      throw new Error(error.response?.data || 'Erro ao buscar perguntas');
    }
  },

  // Método para criar uma nova pergunta
  criarPergunta: async (perguntaData) => {
    try {
      const response = await api.post(`/admin/criar-pergunta`, perguntaData);
      return response.data; // Retorna os dados da pergunta criada
    } catch (error) {
      throw new Error(error.response?.data || 'Erro ao criar pergunta');
    }
  },

  // Método para atualizar uma pergunta existente
  atualizarPergunta: async (id, perguntaData) => {
    try {
      const response = await api.put(`/admin/perguntas/${id}`, perguntaData);
      return response.data; // Retorna os dados da pergunta atualizada
    } catch (error) {
      throw new Error(error.response?.data || 'Erro ao atualizar pergunta');
    }
  },

  // Método para excluir uma pergunta
  excluirPergunta: async (id) => {
    try {
      await api.delete(`/admin/excluir-pergunta/${id}`);
      return 'Pergunta excluída com sucesso';
    } catch (error) {
      throw new Error(error.response?.data || 'Erro ao excluir pergunta');
    }
  },

  // Você pode adicionar outros métodos aqui conforme a necessidade
};

export default PerguntaService;
